/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Verify_Failedmessage1Inputs */

const he_auth_verify_failedmessage1 = /** @type {(inputs: Auth_Verify_Failedmessage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`האימות נכשל. אנא נסו שוב.`)
};

const en_auth_verify_failedmessage1 = /** @type {(inputs: Auth_Verify_Failedmessage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification failed. Please try again.`)
};

/**
* | output |
* | --- |
* | "Verification failed. Please try again." |
*
* @param {Auth_Verify_Failedmessage1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const auth_verify_failedmessage1 = /** @type {((inputs?: Auth_Verify_Failedmessage1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Verify_Failedmessage1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_verify_failedmessage1(inputs)
	return en_auth_verify_failedmessage1(inputs)
});
export { auth_verify_failedmessage1 as "auth_verify_failedMessage" }